import React, { useEffect } from 'react';
import { useRouter } from 'found';
import { makeMutation } from '../../api/helpers';
import { Logout as LogoutMutation } from '../../api/mutations';

function Logout() {
  // set cookies to nothing.
  const { router } = useRouter();

  useEffect(() => {
    const wait = async () => {
      await makeMutation(LogoutMutation, {})
      localStorage.removeItem('current_account');

      router.push('/preauth/login');
    }
    wait()
  }, [router]);

  return <div>Logging you out...</div>;
}

export default Logout;
